import { getShortModelName } from 'components/AITools/utilities/common';
import {
  TISSUE_MODEL_SHORT_NAME,
  TISSUE_SEGMENTATION_MODELS,
} from 'components/AITools/constants/common';

export const checkIfModelRequired = ({ opacityOptions, modelFullName }) =>
  !opacityOptions.disabled(modelFullName);

export const getRequestedModelsShortNames = ({
  options,
  opacityOptions,
  aiModels,
}) => {
  const modelsToRequest = options.filter(
    (option) =>
      checkIfModelRequired({ opacityOptions, modelFullName: option.value }) &&
      !aiModels[getShortModelName(option.value)],
  );

  if (
    !aiModels[TISSUE_MODEL_SHORT_NAME] &&
    checkIfModelRequired({
      opacityOptions,
      modelFullName: TISSUE_SEGMENTATION_MODELS.ML_TISSUE_DATA,
    })
  ) {
    modelsToRequest.push({
      value: TISSUE_SEGMENTATION_MODELS.ML_TISSUE_DATA,
    });
  }

  const requestedModelsShortNames = modelsToRequest.map((modelToRequest) =>
    getShortModelName(modelToRequest.value),
  );

  return requestedModelsShortNames;
};
